import { GiftReviewPage } from './GiftReviewPage'

export default GiftReviewPage
// eslint-disable-next-line import/export
export * from './GiftReviewPage'
